import moment from 'moment';

export default {
    install(app) {
        app.mixin({
            methods: {
                moment: moment
            }
        })

        app.provide('moment', moment)
    }
}
